import { UniButton } from '@/design-system/components/buttons';
import { Icon } from '@/design-system/components/icons/Icon';
import { H4, H6, TextBody, TextCaption, TextTitle } from '@/design-system/components/typography';
import { LayoutContext } from 'contexts/LayoutContext';
import { SxProp, View, Image, useDripsyTheme, styled } from 'dripsy';
import _ from 'lodash';
import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Row } from '@/design-system/components/layout';
import { useNavigation } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { SuspendCardStackParamList } from './type';
import { Card } from '../../../../../../packages/utx-access-client/src/react';
import { PageHeaderModalNative } from '../page/PageHeaderModalNative';
import moment from 'moment-timezone';
import { CardStatus } from '../../enum';

export interface SuspendCardProps {
  onClose: () => void;
  account: string;
  tab?: number;
  record?: Card;
  data?: any;
  refresh?: () => void;
}

export const SuspendCardNativeOneScreen: React.FC<SuspendCardProps> = (props) => {
  const { onClose, account, tab, record, data, refresh } = props;
  const { t } = useTranslation('account-management');
  const layout = useContext(LayoutContext);

  const { theme } = useDripsyTheme();

  const navigation = useNavigation<NativeStackNavigationProp<SuspendCardStackParamList>>();

  const [instructionTime, setInstructionTime] = useState(moment().format('YYYY-MM-DD HH:mm:ss'));

  return (
    <View sx={{ height: '100%', backgroundColor: '$white' }}>
      <PageHeaderModalNative>
        <Row sx={{ justifyContent: 'center', alignItems: 'center', px: '$4', mt: '$5', mb: '$4' }}>
          <View sx={{ textAlign: 'center' }}>
            <TextTitle bold sx={{ color: theme?.colors?.$white as string }}>
              {record?.status == CardStatus.ACTIVE
                ? t('credit-card-suspend-unsuspend-card::glossary.suspend-card')
                : t('credit-card-suspend-unsuspend-card::glossary.unsuspend-card')}
            </TextTitle>
          </View>
        </Row>
      </PageHeaderModalNative>
      <View sx={styles.modal}>
        <View sx={styles.topHeader}>
          <Icon name="checkCircleBlue" height={108} width={108} />
          <H6 bold sx={styles.textHeaderTitle}>
            {record?.status == CardStatus.ACTIVE
              ? t('credit-card-suspend-unsuspend-card::suspend-card-placed.title--suspend-card-placed')
              : t('credit-card-suspend-unsuspend-card::unsuspend-card-placed.title--unsuspend-card-placed')}
          </H6>
          <TextCaption sx={styles.subTitle}>
            {record?.status == CardStatus.ACTIVE
              ? t('credit-card-suspend-unsuspend-card::suspend-card-placed.text--you-have-suspended-card')
              : t('credit-card-suspend-unsuspend-card::unsuspend-card-placed.text--you-have-unsuspended-card')}
          </TextCaption>
        </View>
        <View sx={styles.body}>
          <View sx={{ alignItems: 'center' }}>
            <Image sx={styles.imageSx} source={record?.product?.imageUrl || require('assets/images/worldcard_blank.png')} />
            <View sx={styles.textGroup}>
              <View sx={{ gap: '$1' }}>
                <H6 semiBold sx={{ color: '$white' }}>
                  {record?.embossedName}
                </H6>
                <TextCaption sx={{ color: '$white' }}>**** **** **** {record?.last4}</TextCaption>
              </View>
            </View>
          </View>
          <View
            sx={{
              ...styles.horizontalWrapper,
              ...styles.timeView
            }}>
            <TextBody sx={styles.textLabel}>{t('card-account-management::lock-card.text--instruction-time')}</TextBody>
            <TextCaption semiBold sx={styles.textDebitAmount}>
              {data?.instructionTime || instructionTime || '-'}
            </TextCaption>
          </View>
          <UniButton
            sx={styles.btn}
            labelSx={{ color: '$balck' }}
            label={t('card-account-management::general.button--close')}
            onPress={() => {
              refresh();
              navigation.getParent()?.goBack();
            }}
          />
        </View>
      </View>
    </View>
  );
};

const styles: Record<string, SxProp> = {
  modal: {
    padding: '$5'
  },
  topHeader: {
    justifyContent: 'center',
    alignItems: 'center'
  },
  subTitle: { mb: '$10' },
  horizontalWrapper: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  textLabel: {
    color: '$textSecondary'
  },
  textDebitAmount: {
    mb: '$1',
    color: '$textPrimary'
  },
  textHeaderTitle: {
    mb: '$2',
    textAlign: 'center'
  },
  imageSx: {
    width: 317,
    height: 200
  },
  timeView: {
    mb: '$3',
    mt: '$5'
  },
  refView: {
    mb: '$10'
  },
  btn: {
    height: 44,
    width: '92%',
    position: 'fixed',
    left: 0,
    bottom: 0,
    marginX: 15,
    marginBottom: 30
  },
  textGroup: {
    position: 'absolute',
    width: 317,
    height: 200,
    padding: '$5',
    gap: '$3',
    justifyContent: 'flex-end'
  }
};
